import React from "react";
import "./Footer.css";
import Wave from "../../img/wave.png";
import Linkedin from "@iconscout/react-unicons/icons/uil-linkedin";
import Whatsapp from "@iconscout/react-unicons/icons/uil-whatsapp";
import Gitub from "@iconscout/react-unicons/icons/uil-github";

const Footer = () => {
  return (
    <div className="footer">
      <img src={Wave} alt="" style={{ width: "100%" }} />
      <div className="f-content">
        <span>@2022 Created By Akshay | copyright</span>
        <div className="f-icons">
         <a href="https://www.linkedin.com/in/akshay-g-gouda-1bb424202" smooth={true} spy={true} target="balnk" ><Linkedin color="white" size={"3rem"} /></a>
         <a href="https://wa.me/+918431213804" smooth={true} spy={true} target="blank" > <Whatsapp color="white" size={"3rem"} /></a>
         <a href="https://github.com/akshaygouda0707" smooth={true} spy={true} target="blank" ><Gitub color="white" size={"3rem"} /></a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
